import PropTypes from 'prop-types';

//basic reimbursement
import MS from './Templates/MS'
import NoReimbursementStatement from './Templates/NoReimbursementStatement';
import FfBs from './Templates/FF-BS';
import FfPsDno from './Templates/FF-PS-DNO';
import FfPsBs from './Templates/FF-PS-BS';
import LsDno from './Templates/LS-DNO';
import LsBs from './Templates/LS-BS'
import TemplateNotFound from './Templates/TemplateNotFound';

//basic rent
import BasicRent from './Templates/BasicRent'

//profit share
import PsUtilThreshold from './Templates/PsUtilThreshold';
import PsNoUtilThreshold from './Templates/PsNoUtilThreshold';
import PsLessBr from './Templates/PsLessBr';
import PsAndBr from './Templates/PsAndBr';
import RevenueShare from './Templates/RevenueShare';
import PsBasicRentOnly from './Templates/PsBasicRentOnly';

const StatementTemplateRenderer = ({ statement }) => {

  switch (statement.statementType) {
    //--- basic reimbursement templates ---//
    case 'MS':
      return <MS statement={statement} />;
    case 'LS - BS':
      return <LsBs statement={statement} />;
    case 'LS - DNO':
      return <LsDno statement={statement} />;  
    case 'FF - PS - BS':
      return <FfPsBs statement={statement} />;  
    case 'FF - BS':
      return <FfBs statement={statement} />; 
    case 'FF - PS - DNO':
      return <FfPsDno statement={statement} />;   
    case 'No reimbursement statement':
      return <NoReimbursementStatement statement={statement} />; 
    
    //--- basic rent template ---//
    case 'basic-rent': 
      return <BasicRent statement={statement} />  
    
    //--- profit share templates ---//
    case 'Profit share only (utilisation threshold)':
      return <PsUtilThreshold statement={statement}/>
    case 'Profit share only (no utilisation threshold)':
      return <PsNoUtilThreshold statement={statement}/>
    case 'Profit share LESS basic rent':
      return <PsLessBr statement={statement}/>
    case 'Profit share AND basic rent':
      return <PsAndBr statement={statement}/>
    case 'Revenue share':
      return <RevenueShare statement={statement}/>
    case 'Basic rent only':
      return <PsBasicRentOnly statement={statement}/>
      
    default:
      return <TemplateNotFound />;
  }
};

export default StatementTemplateRenderer;

StatementTemplateRenderer.propTypes = {
  statement: PropTypes.object.isRequired,
};
